<app-main-resource-catalog [scope]="AppScope.MATERIAL"></app-main-resource-catalog>
